var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChevronUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.28 8.22C11.4205 8.07931 11.6112 8.00018 11.81 8H12.19C12.3884 8.0023 12.5783 8.08112 12.72 8.22L17.85 13.36C17.9447 13.4539 17.9979 13.5817 17.9979 13.715C17.9979 13.8483 17.9447 13.9761 17.85 14.07L17.14 14.78C17.0478 14.8741 16.9217 14.9271 16.79 14.9271C16.6583 14.9271 16.5322 14.8741 16.44 14.78L12 10.33L7.56 14.78C7.46612 14.8747 7.33832 14.9279 7.205 14.9279C7.07169 14.9279 6.94389 14.8747 6.85 14.78L6.15 14.07C6.05535 13.9761 6.00211 13.8483 6.00211 13.715C6.00211 13.5817 6.05535 13.4539 6.15 13.36L11.28 8.22Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron_up.5a1c4b40.svg";
export { ForwardRef as ReactComponent };